// removed by extract-text-webpack-plugin
module.exports = {"overflow-ellipsis":"style__overflow-ellipsis___q6Sl0","base-text":"style__base-text___-85m1","large-text":"style__large-text___1hotz","larger-text":"style__larger-text___nJDq6","largest-text":"style__largest-text___2boKd","panel":"style__panel___2IAlb","button":"style__button___DVAWh"};


//////////////////
// WEBPACK FOOTER
// ./components/YesNoOptionPanel/style.scss
// module id = 1290
// module chunks = 0